function cookiesManage() {
    let cookieLocalStorageKey = 'cookieClosed';
    let cookieElement = $(document).find('.cookies-wrapper');
    let cookieAccept = cookieElement.find('.btn');
    let cookieClose = cookieElement.find('.close-cookies');
    let isCookieClosed = localStorage.getItem(cookieLocalStorageKey)

    if (!isCookieClosed) {
        cookieElement.fadeIn();
    }

    cookieAccept.click(function (event) {
        event.preventDefault();
        closeCookieBlock();
    });

    cookieClose.click(function (event) {
        event.preventDefault();
        closeCookieBlock();
    });

    function closeCookieBlock() {
        localStorage.setItem(cookieLocalStorageKey, 'true');
        cookieElement.fadeOut();
    }
}

cookiesManage();